var map = {
	"./0/0/stock.png": 7404,
	"./0/1/stock.png": 7848,
	"./0/2/stock.png": 5516,
	"./0/3/stock.png": 2159,
	"./0/4/stock.png": 6333,
	"./0/5/stock.png": 3073,
	"./1/0/stock.png": 339,
	"./1/1/stock.png": 9131,
	"./1/2/stock.png": 3809,
	"./1/3/stock.png": 9142,
	"./1/4/stock.png": 6029,
	"./10/0/stock.png": 2141,
	"./10/1/stock.png": 8292,
	"./10/2/stock.png": 766,
	"./10/3/stock.png": 3404,
	"./11/0/stock.png": 1391,
	"./11/1/stock.png": 4647,
	"./11/2/stock.png": 7946,
	"./11/3/stock.png": 9995,
	"./12/0/stock.png": 1239,
	"./12/1/stock.png": 4479,
	"./12/2/stock.png": 8955,
	"./12/3/stock.png": 8069,
	"./12/4/stock.png": 8627,
	"./13/0/stock.png": 2518,
	"./13/1/stock.png": 6397,
	"./13/2/stock.png": 646,
	"./13/3/stock.png": 2263,
	"./14/0/stock.png": 5708,
	"./14/1/stock.png": 1053,
	"./14/2/stock.png": 8185,
	"./14/3/stock.png": 4956,
	"./15/0/stock.png": 7936,
	"./15/1/stock.png": 7757,
	"./15/2/stock.png": 7969,
	"./15/3/stock.png": 3285,
	"./15/4/stock.png": 3329,
	"./16/0/stock.png": 6827,
	"./16/1/stock.png": 9804,
	"./16/2/stock.png": 133,
	"./16/3/stock.png": 2304,
	"./16/4/stock.png": 318,
	"./17/0/stock.png": 6102,
	"./17/1/stock.png": 4336,
	"./17/2/stock.png": 5228,
	"./17/3/stock.png": 3553,
	"./17/4/stock.png": 1033,
	"./17/5/stock.png": 3994,
	"./18/0/stock.png": 7545,
	"./18/1/stock.png": 7870,
	"./18/2/stock.png": 8417,
	"./18/3/stock.png": 7275,
	"./18/4/stock.png": 2644,
	"./19/0/stock.png": 4243,
	"./19/1/stock.png": 8117,
	"./19/2/stock.png": 8962,
	"./19/3/stock.png": 1878,
	"./19/4/stock.png": 9791,
	"./2/0/stock.png": 572,
	"./2/1/stock.png": 4489,
	"./2/2/stock.png": 494,
	"./2/3/stock.png": 8211,
	"./20/0/stock.png": 2605,
	"./20/1/stock.png": 2970,
	"./20/2/stock.png": 5475,
	"./20/3/stock.png": 5871,
	"./21/0/stock.png": 7300,
	"./21/1/stock.png": 1362,
	"./21/2/stock.png": 3101,
	"./21/3/stock.png": 7161,
	"./21/4/stock.png": 2430,
	"./22/0/stock.png": 5763,
	"./22/1/stock.png": 9615,
	"./22/2/stock.png": 8542,
	"./22/3/stock.png": 472,
	"./22/4/stock.png": 9264,
	"./23/0/stock.png": 9721,
	"./23/1/stock.png": 662,
	"./23/2/stock.png": 2696,
	"./23/3/stock.png": 210,
	"./23/4/stock.png": 9978,
	"./24/0/stock.png": 7544,
	"./24/1/stock.png": 6986,
	"./24/2/stock.png": 968,
	"./24/3/stock.png": 9332,
	"./25/0/stock.png": 1615,
	"./25/1/stock.png": 3894,
	"./25/2/stock.png": 1449,
	"./25/3/stock.png": 2186,
	"./25/4/stock.png": 4064,
	"./3/0/stock.png": 1494,
	"./3/1/stock.png": 7345,
	"./3/2/stock.png": 2153,
	"./3/3/stock.png": 2420,
	"./4/0/stock.png": 5506,
	"./4/1/stock.png": 8576,
	"./4/2/stock.png": 5951,
	"./4/3/stock.png": 3527,
	"./4/4/stock.png": 1263,
	"./4/5/stock.png": 9134,
	"./5/0/stock.png": 9315,
	"./5/1/stock.png": 9635,
	"./5/2/stock.png": 4685,
	"./5/3/stock.png": 7963,
	"./6/0/stock.png": 5911,
	"./6/1/stock.png": 9890,
	"./6/2/stock.png": 6444,
	"./6/3/stock.png": 1970,
	"./6/4/stock.png": 9226,
	"./7/0/stock.png": 1727,
	"./7/1/stock.png": 5964,
	"./7/2/stock.png": 3856,
	"./7/3/stock.png": 9225,
	"./8/0/stock.png": 7321,
	"./8/1/stock.png": 8864,
	"./8/2/stock.png": 3143,
	"./8/3/stock.png": 5304,
	"./8/4/stock.png": 5772,
	"./9/0/stock.png": 5118,
	"./9/1/stock.png": 6362,
	"./9/2/stock.png": 1212,
	"./9/3/stock.png": 4406,
	"./9/4/stock.png": 4253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9695;